import React from "react";
// Components
import VerifySession from "../../config/verifySession";
import AdminValidation from "../../config/adminValidation";
import CodesManagement from "../../components/codesManagement";

const ProtocolsManagementView = () => (
  <>
    {VerifySession()}
    {AdminValidation()}
    <CodesManagement />
  </>
);

export default ProtocolsManagementView;
